define(['modules/common/models/role'], (Role) => Role.extend({
    url: '/me/role'
}));
